import React, { Component } from "react";
import { connect } from "react-redux";
import {
  postJobs,
  postJobsLoadmore,
  customerList,
  getCustomer,
  metadataStandards,
  metadataStandardsCustom,
  jobSave,
  customerCreate,
  customerCreateReset,
  jobEdit,
  cancelEdit,
  jobUpdateAndList,
  getDevices,
  jobDelete,
  setPrevSelectedDeviceid,
  uploadLantekFiles,
  generateReport,
  getAttachments,
  uploadAttachment,
  deleteAttachment,
  attachmentDownload,
  jobUpdateSyncAndList,
  jobReload,
  checkReportCanBeGenerated,
  checkReportCanBeGeneratedForTreeview,
  addCustomerDetailsWithName,
  addCustomerDetails,
  clearAttachments,
  downloadCsv,
  rengernateImage,
  exportJob,
  downloadExportedJob,
  uploadCometFiles,
  validateLt4JobName,
  updateJobsDefaultOrder,
  saveJobSearchFilter,
  countryStateList,
  loadColumnPresets,
  getSmartFlagProfiles
} from "../../redux/actions";

import {
  getActiveLanguage
} from 'react-localize-redux'

import Jobs from "../../components/jobs";

class JobsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: null,
      page: 1,
      count: 15,
      initiated: false,
      search: []
    };
    this.modalState = null;
  }

  componentWillMount() {
    // Trigger Colum Presets loading action. Happens only once
    const { loadColumnPresets } = this.props;
    loadColumnPresets();

    let searchParams = JSON.parse(sessionStorage.getItem("JOB_SEARCH_PARAMS"));
    const params = searchParams ? [...searchParams.tempSearch] : [];
    this.props.start(
      params,
      this.state.page,
      this.state.count,
      this.props.jobsDefaultOrder
    );
    this.loadStandardAndDevicesAndCustom();
    const { jobSearchFilterSaved, saveJobSearchFilter } = this.props;
    let searchFilter = JSON.parse(sessionStorage.getItem("JOB_SEARCH_FILTER"));
    if (searchFilter && searchParams) {
      saveJobSearchFilter(searchFilter, params, false);
      this.setState({
        filter: searchFilter,
        search: params
      });
    }
    this.props.getCountryStateList(this.props.activeLanguage);
    const profile = this.props.profile;
    if (profile) {
      const activeFeatures = this.props.appSettingReducer?.activeFeatures;
      if (activeFeatures?.some(f => f.featureName === 'smart_flag')) {
        this.props.getSmartFlagProfiles(profile.customerid);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      selectedCustomerId,
      customers,
      searchFilter,
      searchParams
    } = nextProps;
    if (
      nextProps.selectedCustomerId &&
      nextProps.selectedCustomerId != this.props.selectedCustomerId
    ) {
      const selectedCustomerName =
        selectedCustomerId &&
        customers &&
        customers.data.filter(c => c.id == selectedCustomerId)[0].name;
      this.props.addCustomerNameInBreadCrum({
        isNameDisplayed: true,
        cId: selectedCustomerId,
        cName: selectedCustomerName
      });
    }
    if (searchFilter) {
      this.setState({ filter: searchFilter });
    }
    if (searchParams) {
      this.setState({ seacrh: searchParams });
    }
  }

  componentDidUpdate(prevProps) {
    const { searchFilter, searchParams } = this.props;
    if (
      searchFilter &&
      (!this.state.initiated ||
        prevProps.searchFilter !== this.props.searchFilter)
    ) {
      this.setState({
        filter: searchFilter,
        search: searchParams,
        initiated: true
      });
    }
  }

  loadStandardAndDevicesAndCustom = () => {
    const { standards, custom, devices } = this.props;
    if (!devices || !standards || !custom) {
      this.props.getStandards();
      this.props.getDevices();
      this.props.getCustom();
    }
  };

  render() {
    const {
      translate,
      jobs,
      getCustomers,
      getCustomer,
      customers,
      devices,
      custom,
      standards,
      saveEditJob,
      languages,
      create,
      created,
      customerId,
      customer,
      deferLogoUpdate,
      editJob,
      edit,
      cancelEdit,
      deleteJob,
      uploadLantekFiles,
      start,
      prevSelectedDeviceid,
      setPrevSelectedDeviceid,
      form,
      generateReport,
      attachments,
      getAttachments,
      uploadAttachment,
      deleteAttachment,
      attachmentDownload,
      loadMore,
      onSyncChange,
      jobReload,
      checkForReport,
      checkForReportForTreeview,
      selectedCustomerName,
      selectedCustomerId,
      clearAttachments,
      downloadCsv,
      rengernateImage,
      resetCustomer,
      exportJob,
      downloadExportedJob,
      uploadCometFiles,
      validateLt4JobName,
      lantekreportcount,
      cometreportcount,
      selectedLanguage,
      jobsDefaultOrder,
      updateJobsDefaultOrder,
      saveJobSearchFilter,
      saveNewJob,
      countryStates,
      reloadTreeView
    } = this.props;

    const { page, count, filter, search, jobModalError } = this.state;

    if (jobs) {
      return (
        <Jobs
          jobs={jobs}
          translate={translate}
          getCustomers={getCustomers}
          getCustomer={getCustomer}
          customers={customers}
          devices={devices}
          custom={custom}
          standards={standards}
          saveNewJob={saveNewJob}
          saveEditJob={saveEditJob}
          languages={languages}
          create={create}
          created={created}
          customerId={customerId}
          customer={customer}
          deferLogoUpdate={deferLogoUpdate}
          editJob={editJob}
          edit={edit}
          cancelEdit={cancelEdit}
          deleteJob={deleteJob}
          uploadLantekFiles={uploadLantekFiles}
          prevSelectedDeviceid={prevSelectedDeviceid}
          setPrevSelectedDeviceid={setPrevSelectedDeviceid}
          loadMore={loadMore}
          page={page}
          count={count}
          form={form}
          generateReport={generateReport}
          getAttachments={getAttachments}
          attachments={attachments}
          uploadAttachment={uploadAttachment}
          deleteAttachment={deleteAttachment}
          attachmentDownload={attachmentDownload}
          start={start}
          onSyncChange={onSyncChange}
          jobReload={jobReload}
          checkForReport={checkForReport}
          checkForReportForTreeview={checkForReportForTreeview}
          selectedCustomerName={selectedCustomerName}
          selectedCustomerId={selectedCustomerId}
          clearAttachments={clearAttachments}
          downloadCsv={downloadCsv}
          rengernateImage={rengernateImage}
          loadStandardAndDevicesAndCustom={this.loadStandardAndDevicesAndCustom}
          resetCustomer={resetCustomer}
          exportJob={exportJob}
          downloadExportedJob={downloadExportedJob}
          uploadCometFiles={uploadCometFiles}
          validateLt4JobName={validateLt4JobName}
          lantekreportcount={lantekreportcount}
          cometreportcount={cometreportcount}
          selectedLanguage={selectedLanguage}
          updateJobsDefaultOrder={updateJobsDefaultOrder}
          jobsDefaultOrder={jobsDefaultOrder}
          filter={filter}
          search={search}
          saveJobSearchFilter={ saveJobSearchFilter }
          countryStates={countryStates}
          reloadTreeView={reloadTreeView}
          smartFlagProfiles={this.props.smartFlagProfileReducer ? this.props.smartFlagProfileReducer.profiles : []}
          getSmartFlagProfiles={this.props.getSmartFlagProfiles}
          activeFeatures={this.props.appSettingReducer?.activeFeatures}
        />
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => ({
  jobs: state.jobReducer.jobs,
  customers: state.customerReducer.customers,
  devices: state.jobReducer.devices,
  standards: state.jobReducer.standards,
  custom: state.jobReducer.custom,
  languages: state.localeReducer.languages,
  created: state.customerReducer.created,
  customerId: state.customerReducer.customerId,
  customer: state.customerReducer.customer,
  edit: state.jobReducer.edit,
  prevSelectedDeviceid: state.jobReducer.prevSelectedDeviceid,
  form: state.jobReducer.form,
  attachments: state.testsReducer.attachments,
  customerNameDisplayed: state.jobReducer.customerNameDisplayed,
  selectedCustomerId: state.jobReducer.selectedCustomerId,
  selectedCustomerName: state.jobReducer.selectedCustomerName,
  lantekreportcount: state.authReducer.lantekreportcount,
  cometreportcount: state.authReducer.cometreportcount,
  selectedLanguage: state.languageReducer.selectedLanguage,
  jobsDefaultOrder: state.jobReducer.jobsDefaultOrder,
  searchFilter: state.testsReducer.jobSearchFilter,
  searchParams: state.testsReducer.searchParams,
  countryStates: state.customerReducer.countryStates,
  activeLanguage: getActiveLanguage(state.localeReducer).code,
  fileUploadSettings: state.appSettingReducer.fileUploadSettings,
  profile: state.profileReducer.profile,
  ...state
});

const mapDispatchToProps = (dispatch, props) => ({
  start: (filter, page, count, order) => {
    dispatch(postJobs(filter, page, count, props.match.params.cid, order));
    if (props.match.params.cid) {
      dispatch(
        addCustomerDetails({
          isNameDisplayed: true,
          cId: props.match.params.cid
        })
      );
    } else {
      dispatch(
        addCustomerDetailsWithName({
          isNameDisplayed: undefined,
          cId: undefined,
          cName: undefined
        })
      );
    }
  },
  loadMore: (filter, page, count, order) => {
    dispatch(
      postJobsLoadmore(filter, page, count, props.match.params.cid, order)
    );
  },
  getCustomers: pager => {
    dispatch(customerList(pager));
  },
  getCustomer: cid => {
    dispatch(getCustomer(cid));
  },
  getStandards: () => {
    dispatch(metadataStandards());
  },
  getDevices: () => {
    dispatch(getDevices());
  },
  getCustom: () => {
    dispatch(metadataStandardsCustom());
  },
  saveNewJob: (job, customer) => {
    return dispatch(jobSave(job, customer));
  },
  saveEditJob: (job, customerId) => {
    return dispatch(jobUpdateAndList(job, customerId));
  },
  loadColumnPresets: () => {
    return dispatch(loadColumnPresets());
  },
  create: customer => {
    return dispatch(
      customerCreate("customer", customer, {
        pageno: 0,
        pagesize: 0
      })
    );
  },
  deferLogoUpdate: () => {
    dispatch(customerCreateReset());
  },
  editJob: id => {
    dispatch(
      customerList({
        pageno: 0,
        pagesize: 0
      })
    );
    dispatch(jobEdit(id));
  },
  cancelEdit: () => {
    dispatch(cancelEdit());
  },
  deleteJob: (id, customerId) => {
    dispatch(jobDelete(id, customerId));
  },
  setPrevSelectedDeviceid: id => {
    dispatch(setPrevSelectedDeviceid(id));
  },
  uploadLantekFiles: data => {
    return dispatch(uploadLantekFiles(data, props.match.params.cid));
  },
  generateReport: data => {
    dispatch(generateReport(data));
  },
  getAttachments: (jobid, testid) => {
    dispatch(getAttachments(jobid, testid));
  },
  uploadAttachment: (file, jobid, testid) => {
    dispatch(uploadAttachment(file, jobid, testid, props.match.params.cid));
  },
  deleteAttachment: file => {
    dispatch(deleteAttachment(file, props.match.params.cid));
  },
  attachmentDownload: file => {
    dispatch(attachmentDownload(file));
  },
  onSyncChange: job => {
    dispatch(jobUpdateSyncAndList(job, props.match.params.cid));
  },
  jobReload: jobId => {
    dispatch(jobReload(jobId));
  },
  checkForReport: ({ testids, selectall, jobid }) => {
    return dispatch(checkReportCanBeGenerated({ testids, selectall, jobid }));
  },
  checkForReportForTreeview: ({ nodeId, jobId, includeChildren }) => {
    return dispatch(checkReportCanBeGeneratedForTreeview({ nodeId, jobId, includeChildren }));
  },
  addCustomerNameInBreadCrum: ({ isNameDisplayed, cId, cName }) => {
    dispatch(addCustomerDetailsWithName({ isNameDisplayed, cId, cName }));
  },
  clearAttachments: () => {
    dispatch(clearAttachments());
  },
  downloadCsv: (jobId, jobName) => {
    dispatch(downloadCsv({ jobId, jobName }));
  },
  rengernateImage: jobid => {
    dispatch(rengernateImage(jobid));
  },
  resetCustomer: () => {
    dispatch(customerCreateReset());
  },
  exportJob: (jobid, exportCsv) => {
    dispatch(exportJob(jobid, props.match.params.cid, exportCsv));
  },
  downloadExportedJob: (jobid, csvfile) => {
    dispatch(downloadExportedJob(jobid, csvfile));
  },
  uploadCometFiles: data => {
    return dispatch(uploadCometFiles(data, props.match.params.cid));
  },
  validateLt4JobName: jobname => {
    return dispatch(validateLt4JobName(jobname));
  },
  updateJobsDefaultOrder: order => {
    return dispatch(updateJobsDefaultOrder(order));
  },
  saveJobSearchFilter: (searchFilter, searchParams, jobSearchFilterSaved) => {
    dispatch(
      saveJobSearchFilter(searchFilter, searchParams, jobSearchFilterSaved)
    );
  },
  getCountryStateList: (languageCode) => {
    dispatch(countryStateList(languageCode));
  },
  getSmartFlagProfiles: (organisationId) => {
    dispatch(getSmartFlagProfiles(organisationId));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JobsPage);
